var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "export-settings" }, [
    _c("div", { staticClass: "layout" }, [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("table.whichColumnsToDownload"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "hint" }, [
            _vm._v(_vm._s(_vm.$t("table.selectFieldsEditNamesFormats"))),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "toolbar" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "dashed", icon: "plus" },
                on: { click: _vm.addColumn },
              },
              [_vm._v(_vm._s(_vm.$t("table.addNewColumn")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "columns" },
          _vm._l(_vm.columns, function (col, idx) {
            return _c("div", { key: col.id, staticClass: "column-row" }, [
              _c(
                "div",
                {
                  staticClass: "col-content",
                  class: { disabled: !col.include },
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-main" },
                    [
                      _c("a-switch", {
                        attrs: { checked: col.include, size: "small" },
                        on: {
                          change: function ($event) {
                            return _vm.setInclude(idx, $event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "index" }, [
                        _vm._v("#" + _vm._s(idx + 1)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("table.excelColumnName"))),
                          ]),
                          _vm._v(" "),
                          _c("a-input", {
                            attrs: {
                              value: col.label,
                              placeholder: _vm.$t("table.columnName"),
                              size: "small",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setLabel(idx, $event.target.value)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("label", [_vm._v(_vm._s(_vm.$t("table.field")))]),
                          _vm._v(" "),
                          _c("CustomPicker", {
                            attrs: {
                              value: col.fieldId,
                              items: _vm.fieldItems,
                              idKey: "_id",
                              labelKey: "name",
                              multiple: false,
                              label: "",
                              icon: "view_column",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.setField(idx, $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.colField(col) &&
                      !_vm.isExcludedType(_vm.colField(col))
                        ? [
                            _vm.colField(col).valueType === "date"
                              ? _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("table.dateFormat"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        value:
                                          col.dateFormat ||
                                          _vm.defaultDateFormat,
                                        items: _vm.dateFormatItems,
                                        idKey: "id",
                                        labelKey: "label",
                                        multiple: false,
                                        label: "",
                                        icon: "event",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setDateFormat(idx, $event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.colField(col).valueType === "boolean"
                              ? _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("table.booleanFormat"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        value:
                                          col.booleanFormat || "true-false",
                                        items: _vm.booleanFormatItems,
                                        idKey: "id",
                                        labelKey: "label",
                                        multiple: false,
                                        label: "",
                                        icon: "toggle_on",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setBooleanFormat(
                                            idx,
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.colField(col).valueType === "asset"
                              ? _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("table.assetField"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        value: col.assetProp || "cdnUrl",
                                        items: _vm.assetPropItems,
                                        idKey: "id",
                                        labelKey: "label",
                                        multiple: false,
                                        label: "",
                                        icon: "image",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setAssetProp(idx, $event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.colField(col).valueType === "objectId" &&
                            _vm.colField(col).fieldType === "user"
                              ? _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("table.userField"))),
                                    ]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        value: col.userProp || "name",
                                        items: _vm.userPropItems,
                                        idKey: "id",
                                        labelKey: "label",
                                        multiple: false,
                                        label: "",
                                        icon: "person",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setUserProp(idx, $event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.colField(col).valueType === "objectId" &&
                            _vm.colField(col).fieldType === "contact"
                              ? _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("table.contactField"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        value: col.contactProp || "fullname",
                                        items: _vm.contactPropItems,
                                        idKey: "id",
                                        labelKey: "label",
                                        multiple: false,
                                        label: "",
                                        icon: "contacts",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setContactProp(idx, $event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.colField(col).valueType === "objectId" &&
                            _vm.colField(col).fieldType === "ticket"
                              ? _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("table.ticketField"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        value: col.ticketProp || "subject",
                                        items: _vm.ticketPropItems,
                                        idKey: "id",
                                        labelKey: "label",
                                        multiple: false,
                                        label: "",
                                        icon: "confirmation_number",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setTicketProp(idx, $event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.colField(col).valueType === "objectId" &&
                            _vm.colField(col).fieldType === "task"
                              ? _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("table.taskField"))),
                                    ]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        value: col.taskProp || "title",
                                        items: _vm.taskPropItems,
                                        idKey: "id",
                                        labelKey: "label",
                                        multiple: false,
                                        label: "",
                                        icon: "check_circle",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setTaskProp(idx, $event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.colField(col).valueType === "objectId" &&
                            _vm.colField(col).fieldType === "conversation"
                              ? _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("table.conversationField")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        value: col.conversationProp || "_id",
                                        items: _vm.conversationPropItems,
                                        idKey: "id",
                                        labelKey: "label",
                                        multiple: false,
                                        label: "",
                                        icon: "chat",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setConversationProp(
                                            idx,
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.colField(col).valueType === "array" &&
                            _vm.colField(col).fieldType === "tag"
                              ? _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("table.tagField"))),
                                    ]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        value: col.tagProp || "name",
                                        items: _vm.tagPropsItems,
                                        idKey: "id",
                                        labelKey: "label",
                                        multiple: false,
                                        label: "",
                                        icon: "tag",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setTagProp(idx, $event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.colField(col).valueType === "objectId" &&
                            _vm.colField(col).fieldType === "referral"
                              ? _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("table.referralField"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        value: col.referralProp || "headline",
                                        items: _vm.referralPropsItems,
                                        idKey: "id",
                                        labelKey: "label",
                                        multiple: false,
                                        label: "",
                                        icon: "ads_click",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setReferralProp(
                                            idx,
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.colField(col).valueType === "objectId" &&
                            _vm.colField(col).fieldType === "channel"
                              ? _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(_vm.$t("table.channelField"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        value: col.channelProp || "name",
                                        items: _vm.channelPropItems,
                                        idKey: "id",
                                        labelKey: "label",
                                        multiple: false,
                                        label: "",
                                        icon: "hub",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.setChannelProp(idx, $event)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.colField(col).valueType === "objectId" &&
                            _vm.colField(col).fieldType === "linked-record"
                              ? _c("div", { staticClass: "field" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(_vm.$t("table.linkedRecord"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "muted" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("table.onlyIdWillBeAdded"))
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("a-button", {
                        staticClass: "delete-btn",
                        attrs: { size: "small", icon: "delete" },
                        on: {
                          click: function ($event) {
                            return _vm.removeColumn(idx)
                          },
                        },
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c(
            "div",
            {
              staticClass: "header preview-header",
              on: { click: _vm.togglePreview },
            },
            [
              _c("div", { staticClass: "title" }, [
                _c(
                  "i",
                  {
                    staticClass: "material-icons expand-icon",
                    class: { expanded: _vm.showPreview },
                  },
                  [_vm._v("expand_more")]
                ),
                _vm._v(
                  "\n                    Önizleme (ilk 10 kayıt)\n                "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "preview-slide" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showPreview,
                    expression: "showPreview",
                  },
                ],
                staticClass: "preview",
              },
              [
                _c("div", { staticClass: "preview-scroll" }, [
                  _c("table", { staticClass: "preview-table" }, [
                    _c("thead", [
                      _c(
                        "tr",
                        _vm._l(_vm.activeColumns, function (c) {
                          return _c("th", { key: c.id }, [
                            _vm._v(_vm._s(c.label)),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.previewRows, function (row, rIdx) {
                        return _c(
                          "tr",
                          { key: "r-" + rIdx },
                          _vm._l(_vm.activeColumns, function (c) {
                            return _c("td", { key: "c-" + c.id }, [
                              _vm._v(_vm._s(row[c.label])),
                            ])
                          }),
                          0
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "footer" },
      [
        _c(
          "a-button",
          {
            on: {
              click: function ($event) {
                return _vm.$emit("cancel")
              },
            },
          },
          [_vm._v("İptal")]
        ),
        _vm._v(" "),
        _c(
          "a-button",
          { attrs: { type: "primary" }, on: { click: _vm.start } },
          [_vm._v("Başlat")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }